import { httpClient } from "./httpClient";

const getAllProbationQuestionSet = (query) => {
  return httpClient.get(`/probation-question-set`, { params: query });
};

const addProbationQuestionSet = (formData) => {
  return httpClient.post(`/probation-question-set`, formData);
};

const updateProbationQuestionSet = (formData) => {
  return httpClient.put(`/probation-question-set/${formData.idProbationQuestionSet}`, formData);
};

const updateProbationQuestionSetStatus = (formData) => {
  return httpClient.put(`/probation-question-set/${formData.idProbationQuestionSet}/status`, formData);
};

const updateProbationQuestionStatus = (formdata) => {
  return httpClient.put(`/probation-question-status`, formdata);
};

const updateProbationEmployee = (formData) => {
  return httpClient.put(`/probation/employee-probation/${formData.idProbation}`, formData);
};

const updateProbationManager = (formData) => {
  return httpClient.put(`/probation/manager-probation/${formData.idProbation}`, formData);
};

const updateProbationAdmin = (formData) => {
  return httpClient.put(`/probation/admin-probation/${formData.idProbation}`, formData);
};

const getProbationEmployee = () => {
  return httpClient.get("/probation/employee-probation");
};

const getProbationEmployees = () => {
  return httpClient.get(`/employees-probation`);
};

const getProbation = (idProbation) => {
  return httpClient.get(`/probation/${idProbation}`);
};

const getProbationResult = (idEmp) => {
  return httpClient.get(`/probation-result/${idEmp}`);
};

const getProbationAndAnswer = (formData) => {
  return httpClient.get(`/probation/result-probation`, { params: formData });
};

const getProbationEmployeeAnswer = (idEmployees) => {
  return httpClient.get(`probation/employee/${idEmployees}`);
};

const getProbationAdmin = (query) => {
  return httpClient.get(`probation/admin-probation`, { params: query });
};

export default {
  getAllProbationQuestionSet,
  addProbationQuestionSet,
  updateProbationQuestionSet,
  updateProbationQuestionSetStatus,
  updateProbationQuestionStatus,
  updateProbationEmployee,
  updateProbationManager,
  updateProbationAdmin,
  getProbationEmployee,
  getProbationEmployees,
  getProbation,
  getProbationResult,
  getProbationAndAnswer,
  getProbationEmployeeAnswer,
  getProbationAdmin,
};
